module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "thehistoryof01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  }, [_vm._v("The History of the Russian Officer Corps: An Overview")])]), _vm._v(" "), _c('h2', {
    staticClass: "head2"
  }, [_vm._v("Origins, Enlistment and Promotions")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The beginning of the Russian officer corps is closely tied to Peter the Great’s military reforms. Peter realized the importance of having well-trained and professional officers leading his army."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent1",
      "id": "theft1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" Modernizing the state was especially crucial in light of the Great Northern War between Russia and Sweden (1700-1721). When the Swedish army, under the maverick King Charles XII, defeated the Russians from 1700 to 1704, Peter began inviting foreign officers to train and lead his troops."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent2",
      "id": "theft2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" He hired 700 foreign officers in 1698, though the majority of them were fired within a couple of years."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent3",
      "id": "theft3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" In most cases, these men were adventurers, renegades, or inexperienced officers with military experience but no prospects in their native countries. General A. Golovin complained, “They had no experience or knowledge of military affairs and had to be themselves trained first…. [I]t is better to conscript [Russian nobles], educate and train them.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent4",
      "id": "theft4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Peter shifted his attention to recruiting Russian nobility and creating the professional officer corps."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent5",
      "id": "theft5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" To increase the number of nobles available for service, he established obligatory military service. He also prohibited noblemen younger than 60 from joining the monastery. Those who avoided service faced persecution and confiscation of property. Noblemen were eligible for conscription at 13, serving first as soldiers and then as officers. Peter prohibited granting officer’s rank to any noble who did not serve as a soldier in the Guard units. He hoped this arrangement would enable noblemen to gain experience while serving in the lower ranks of regiments. In 1700, 1,091 Russian nobles were conscripted into the army. Within two years, another 2,913 were reviewed and 940 started service in the army."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent6",
      "id": "theft6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" In 1700 there were 264 officer vacancies in eight infantry regiments; 33 of the 78 positions were filled by foreigners."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent7",
      "id": "theft7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" By 1701, a third of the 1,137 infantry officers were foreigners. In contrast to the infantry regiments, virtually every cavalry officer was of Russian origin."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent8",
      "id": "theft8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Although army commanders could nominate nobles for officer’s rank, two special institutions, Voennii Prikaz (Military Agency) and Inozemnii Prikaz (Foreign Agency), supervised and confirmed these promotions. The nobles exploited a loophole in this system by enlisting their children in the Guard at birth or during infancy. When the children were grown, they already had officer’s rank without any experience or training. Peter tried to prohibit this procedure by requiring all officers in the regiment to vote on granting new officer rank, with the emperor having the final say. In 1764, new regulations prohibited enlisting any youth before age 15. The only exception was children of soldiers, who could be assigned to units as clerks or musicians before age 15."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent9",
      "id": "theft9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" Emperor Alexander forbade accepting noblemen in the Quartermaster Section of the Imperial Retinue and the artillery before age."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent10",
      "id": "theft10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Still, this process continued for decades through nepotism and rampant army corruption. While many young noblemen began their service as rank and file soldiers, others from prominent families with connections were enrolled in regiments as infants and granted leaves until they completed their “studies” at home. For example, future Field Marshal Rumyantsev enlisted in the Imperial Guard at age five, future Minister of Police Alexander Balashov joined the Guard at age six, and Senator Bibikov’s son enlisted at age two and conferred officer’s rank by age nine. Peter Volkon sky (1776-1852) was enlisted in the Life Guard Preobrazhensk Regiment on the day of his baptism. He began active service at 16 and received the rank of ensign within a matter of weeks. Two years later, Volkonsky was already an adjutant in his own regiment. Similarly, Prince Peter Dolgoruky was enlisted in the Life Guard Izmailovsk Regiment on 15 March 1778 at two and a half months old. He became a captain at 15, major at 16, colonel at 20, and major general at 21. These Guard officers took advantage of their status and transferred to the Regular Army, receiving a two-rank promotion.(14) "), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent11",
      "id": "theft11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Patronage was important for finding any position or vacancy because of the abun dance of young noblemen ready for service. Sergey Glinka noted that new appointments usually took place on the first day of each new year in the Guard regiments. This way, at the end of December, the secretary would be pestered with questions such as, “Will my son get in?” or “Has my nephew been put on the list?”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent12",
      "id": "theft12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" Another contemporary described the significance of becoming an officer by stating, “Everyone who has obtained his first officer rank and a sword knows that there is scarcely any pleasure on earth to compare with this reward.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent13",
      "id": "theft13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6773a2dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_thehistoryof01.vue
// module id = 96
// module chunks = 0